import React from "react";
import "./brand-logo.css";
import logoStandard from "../../assets/better-intentions-logo-s.png";
import logoReverse from "../../assets/better-intentions-logo-r.png";

function normalizeColor(value) {
  return String(value || "").trim().toLowerCase().replace(/\s+/g, "");
}

function parseHexToRgb(value) {
  if (!value.startsWith("#")) return null;
  const hex = value.slice(1);
  if (hex.length === 3) {
    const r = parseInt(hex[0] + hex[0], 16);
    const g = parseInt(hex[1] + hex[1], 16);
    const b = parseInt(hex[2] + hex[2], 16);
    if ([r, g, b].some(Number.isNaN)) return null;
    return { r, g, b };
  }
  if (hex.length === 6) {
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    if ([r, g, b].some(Number.isNaN)) return null;
    return { r, g, b };
  }
  return null;
}

function parseRgbToRgb(value) {
  const match = value.match(/^rgba?\((\d+),(\d+),(\d+)/);
  if (!match) return null;
  const r = Number(match[1]);
  const g = Number(match[2]);
  const b = Number(match[3]);
  if ([r, g, b].some(Number.isNaN)) return null;
  return { r, g, b };
}

function isLightColor(value) {
  const color = normalizeColor(value);
  if (!color) return false;
  if (color === "white") return true;
  if (color === "black") return false;

  const rgb = parseHexToRgb(color) || parseRgbToRgb(color);
  if (!rgb) return false;

  const luminance = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
  return luminance >= 0.65;
}

export default function BrandLogo({
  className = "",
  alt = "Better Intentions",
  title = "Better Intentions logo",
  textColor = "#0f0f12",
  draggable = false,
  ...props
}) {
  const classes = ["brandLogo", className].filter(Boolean).join(" ");
  const { style, ...restProps } = props;
  const logoSrc = isLightColor(textColor) ? logoReverse : logoStandard;

  return (
    <img
      src={logoSrc}
      alt={alt}
      title={title}
      className={classes}
      draggable={draggable}
      style={{
        display: "block",
        width: "100%",
        height: "auto",
        ...style,
      }}
      {...restProps}
    />
  );
}
